import { api } from './client';

// backend/api/search.py requires `q` and plural type names
// (messages, summaries, bookmarks). The checkboxes use the singular
// source_type values the results come back with.
const SEARCH_TYPE_PARAM = {
  message: 'messages',
  messages: 'messages',
  summary: 'summaries',
  summaries: 'summaries',
  bookmark: 'bookmarks',
  bookmarks: 'bookmarks',
  import: 'import_chunks',
  import_chunk: 'import_chunks',
  import_chunks: 'import_chunks',
};

export function searchQuery(path, query, types = []) {
  const params = new URLSearchParams();
  params.set('q', query ?? '');
  const mapped = [];
  (types || []).forEach((type) => {
    const name = SEARCH_TYPE_PARAM[type] || type;
    if (name && !mapped.includes(name)) mapped.push(name);
  });
  if (mapped.length > 0) params.set('types', mapped.join(','));
  return `${path}?${params.toString()}`;
}

export const searchApi = {
  searchStory: (storyId, query, types = []) => (
    api.get(searchQuery(`/stories/${storyId}/search`, query, types))
  ),
  searchProject: (projectId, query, types = []) => (
    api.get(searchQuery(`/projects/${projectId}/search`, query, types))
  ),
};
